import { useMutation } from '@apollo/client';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import { LOGOUT } from './graphql/Mutations';

const Logout = () => {
  const { dispatch } = useContext(AppContext);
  const [logout, { loading, error, data }] = useMutation(LOGOUT, {
    onError() {},
  });

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <LoaderComponent />;

  if (error) {
    dispatch({ type: 'LOGOUT' });
    // eslint-disable-next-line no-undef
    window.location = ROUTES?.LOGIN;
    return null;
  }

  if (data) {
    dispatch({ type: 'LOGOUT' });
    // eslint-disable-next-line no-undef
    window.location = ROUTES?.LOGIN;
    return null;
  }

  return null;
};

export default Logout;
